<template>
  <div class="preload-btn">
    <svg id="spinner" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 10C20 12.2013 19.2736 14.3412 17.9335 16.0876C16.5934 17.8341 14.7145 19.0895 12.5882 19.6593C10.4619 20.229 8.20694 20.0812 6.17317 19.2388C4.13939 18.3964 2.44042 16.9064 1.33975 15C0.239075 13.0936 -0.201781 10.8772 0.0855513 8.69474C0.372884 6.51223 1.37235 4.48552 2.92893 2.92893C4.48552 1.37235 6.51223 0.372884 8.69474 0.0855515C10.8772 -0.201781 13.0936 0.239075 15 1.33975L13.9021 3.24135C12.4143 2.38236 10.6846 2.03831 8.98134 2.26255C7.27807 2.48679 5.69638 3.26679 4.48158 4.48158C3.26679 5.69638 2.48679 7.27807 2.26255 8.98135C2.03831 10.6846 2.38236 12.4143 3.24135 13.9021C4.10034 15.3899 5.42625 16.5527 7.01346 17.2102C8.60066 17.8676 10.3604 17.9829 12.0199 17.5383C13.6793 17.0937 15.1457 16.1139 16.1915 14.7509C17.2373 13.3879 17.8042 11.718 17.8042 10H20Z"
        fill="white" />
    </svg>
  </div>
</template>
<style scoped>
.preload-btn {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: var(--secondary-button-regular);
}

@-webkit-keyframes rotating /* Safari and Chrome */ {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
#spinner {
  -webkit-animation: rotating 2s linear infinite;
  -moz-animation: rotating 2s linear infinite;
  -ms-animation: rotating 2s linear infinite;
  -o-animation: rotating 2s linear infinite;
  animation: rotating 2s linear infinite;
}
</style>
